<template>

	<div
		class="widthFull relative whiteBg--repeat min-height-calc--footer"
		id="faq"
	>
		<loading v-if="loadingState" />

		<div class="container-fluid">
			<div class="row pb-0 center">
				<div class="col-12 pt-2">
					<h3 class="  Bold py-2 color-2 pt-5">
						Faq </h3>

				</div>
			</div>
		</div>

		<div class="container mt-5 ">

			<badger-accordion class=" pt-4">

				<badger-accordion-item>
					<template
						slot="header"
						class="center"
					>Come si partecipa alla manifestazione a premio?</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Per partecipare alla manifestazione a premio devi acquistare, dal 01 marzo 2022 al 30 aprile 2022, con uno scontrino parlante almeno un prodotto di Birra Moretti Filtrata a Freddo da 55cl. <br><br>
						Verranno ritenuti validi solo gli scontrini “parlanti” – o un documento equiparabile - in cui sono indicati, totalmente o almeno parzialmente, i prodotti Birra Moretti Filtrata a Freddo da 55cl acquistati (le seguenti diciture generiche, REP 01/REPARTO 1/BIRRA ad esempio non saranno ritenute valide). La società promotrice si riserva inoltre di effettuare gli opportuni controlli di coerenza del costo del prodotto promozionato acquistato ed indicato nello scontrino.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Con lo stesso scontrino/ricevuta si può partecipare una sola volta?</template>
					<template
						slot="content"
						class="bbaLightColor"
					>

						I consumatori potranno partecipare più volte al concorso, utilizzando ogni volta scontrini/ricevute diversi. Gli scontrini/ricevute dovranno avere sempre data e orario di partecipazione compresi nel periodo promozionale e antecedenti alla data e all’ora di effettuazione della partecipazione. <br><br>

						Il partecipante potrà accedere al concorso con le seguenti due modalità: <br><br>

						1. tramite WEB collegandosi al sito birramoretti.it ed accedendo alla sezione dedicata alla promozione (birramoretti.it/vinciunacena);
						tramite WhatsApp® dopo la prima registrazione al sito birramoretti.it accedendo alla sezione dedicata alla promozione (birramoretti.it/vinciunacena) il partecipante deve inviare un messaggio con la foto dello scontrino al numero dedicato 3917054053. <br>

						2. Solo per facilitare la partecipazione alcuni materiali promozionali presenti nei punti di vendita conterranno un QR-CODE che permetterà al concorrente, se lo desidera, di accedere direttamente ai canali WEB e WhatsApp inquadrando il QR-CODE.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Chi può partecipare al concorso?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						I consumatori maggiorenni e residente/domiciliati in Italia che hanno acquistato, dal 01 marzo 2022 al 30 aprile 2022, con scontrino parlante, almeno un prodotto di Birra Moretti Filtrata a Freddo da 55cl.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Quanto dura il concorso?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Il concorso dura dal 01 marzo 2022 al 30 aprile 2022.
					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">C’è un limite di volte in cui posso partecipare?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Ogni consumatore potrà partecipare più volte al concorso, utilizzando ogni volta scontrini diversi, ma potrà vincere UN SOLO PREMIO NEL CORSO DELL’INTERA INIZIATIVA. Se, in fase di convalida, più di una vincita instant win risultasse assegnata allo stesso partecipante, le vincite eccedenti saranno annullate.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Come faccio a modificare i miei dati personali?</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Basta accedere alla sezione “I tuoi dati” e aggiornare le informazioni precedentemente inserite.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Quali sono i premi in palio? </template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Il concorso mette in palio n.61 PREMI (un premio al giorno) consistenti ciascuno in una cena con Chef a domicilio di Chefbooking per 6 persone (un vincitore + cinque ospiti), tutti maggiorenni. Menù Sharing food composto da 6 portate.
						L’evento potrà essere riservato con minimo 14 giorni di preavviso, salvo disponibilità dello chef e del vincitore. Periodo di fruizione entro il 30 Novembre 2022.
						Nel caso in cui gli ospiti fossero un numero inferiore rispetto a cinque il vincitore non avrà diritto ad alcun rimborso o premio alternativo. Dovranno essere a carico del vincitore i costi di eventuali ospiti aggiuntivi, quindi in numero maggiore rispetto a quelli indicati nella descrizione del premio del presente regolamento.
						Tutte le eventuali spese e gli extra non compresi nel premio sono a carico del vincitore.
						Il premio non è cedibile e non può essere trasferito dal vincitore ad un altro soggetto.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Quante volte posso vincere un premio?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Si può vincere un solo premio nel corso dell’intera iniziativa.
					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">E se non vinco nulla?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Tieni accesa la speranza! Gli scontrini validi non vincenti parteciperanno all’eventuale estrazione finale dei premi non assegnati o non convalidati che si terrà entro il 31 maggio 2022.
					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Non riesco ad accedere al mio profilo. Come posso fare?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Puoi recuperare la password utilizzata per la registrazione usando il pulsante “Hai dimenticato la password?” in fase di login. Lo username è l’indirizzo email con cui hai effettuato la registrazione.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">In fase di registrazione compare il messaggio che l’email utilizzata è già esistente. Come mai?

					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Se compare il messaggio che l’email inserita è già esistente vuol dire che ti sei già registrato. Se hai dimenticato la password clicca sul link “Hai dimenticato la password?”
					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Non ricordo la password per accedere. Cosa posso fare?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Se non ricordi la password, clicca sul link “Hai dimenticato la password?”, ti verrà inviata una e-mail con le istruzioni per impostare nuovamente la password.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Non mi è arrivata la e-mail di conferma registrazione / riepilogo dati. Come mai?

					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Controlla nella cartella di posta indesiderata. Assicurati che la mailbox non risulti piena, l’indirizzo di posta elettronica fornito in fase di registrazione non sia errato o incompleto, la mailbox non risulti disabilitata.

					</template>
				</badger-accordion-item>

				<badger-accordion-item>
					<template slot="header">Non mi è arrivata la e-mail di conferma registrazione/riepilogo dati. Come mai?
					</template>
					<template
						slot="content"
						class="bbaLightColor"
					>
						Controlla nella cartella di posta indesiderata. Assicurati che la mailbox non risulti piena,
						l’indirizzo di posta elettronica fornito in fase di registrazione non sia errato o incompleto, la mailbox non risulti disabilitata.
					</template>
				</badger-accordion-item>

			</badger-accordion>

		</div>
	</div>

	<!-- 
  <div class="container mb-5 mt-5 pt-3">
    <div class="row">
      <div class="col page-header">
        <h1>FAQ</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div id="accordion">
          <div class="card">
            <div class="card-header" id="heading1">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse1"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Quando posso partecipare?
                </button>
              </h5>
            </div>
            <div
              id="collapse1"
              class="collapse"
              aria-labelledby="heading1"
              data-parent="#accordion"
            >
              <div class="card-body">
                Puoi partecipare dal 18 gennaio all’8 marzo 2021.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading2">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse2"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Posso partecipare se sono minorenne?
                </button>
              </h5>
            </div>
            <div
              id="collapse2"
              class="collapse"
              aria-labelledby="heading2"
              data-parent="#accordion"
            >
              <div class="card-body">
                Possono partecipare solo i maggiorenni al momento della
                registrazione, residenti sul territorio italiano e Repubblica di
                San Marino.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading3">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse3"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Quali prodotti devo acquistare per partecipare al concorso?
                </button>
              </h5>
            </div>
            <div
              id="collapse3"
              class="collapse"
              aria-labelledby="heading3"
              data-parent="#accordion"
            >
              <div class="card-body">
                Devi acquistare, in un unico atto di acquisto, almeno 2 prodotti
                delle linea Glade a tua scelta fra quelli disponibili presso il
                punto vendita. Il documento d’acquisto parlante sarà valido per
                una sola partecipazione anche se contenente un numero maggiore
                di prodotti rispetto a quanto richiesto.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading4">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse4"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Dove posso acquistare i prodotti per partecipare al concorso?
                </button>
              </h5>
            </div>
            <div
              id="collapse4"
              class="collapse"
              aria-labelledby="heading4"
              data-parent="#accordion"
            >
              <div class="card-body">
                Sul territorio italiano, presso i punti vendita fisici che
                commercializzano i prodotti in promozione o su siti e-commerce
                italiani.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading5">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse5"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Quali sono le modalità di gioco?
                </button>
              </h5>
            </div>
            <div
              id="collapse5"
              class="collapse"
              aria-labelledby="heading5"
              data-parent="#accordion"
            >
              <div class="card-body">
                Puoi partecipare con i dati del documento d’acquisto parlante
                attestante l’acquisto di almeno 2 prodotti Glade, registrandoti
                prima online su questo sito. Tieni a portata di mano il
                documento d’acquisto parlante (ovvero lo scontrino) se hai
                acquistato in un punto di vendita fisico oppure l’ordine di
                acquisto regolarmente saldato/ricevuta se hai effettuato
                l’acquisto su un sito e-commerce italiano.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading6">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse6"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Sul documento d’acquisto c’è una descrizione generica dei
                  prodotti, posso partecipare?
                </button>
              </h5>
            </div>
            <div
              id="collapse6"
              class="collapse"
              aria-labelledby="heading6"
              data-parent="#accordion"
            >
              <div class="card-body">
                No, puoi partecipare solo se sei in possesso di un documento
                d’acquisto parlante, ovvero riportante chiaramente la
                descrizione dei prodotti acquistati.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading7">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse7"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Se acquisto sul web posso partecipare?
                </button>
              </h5>
            </div>

            <div
              id="collapse7"
              class="collapse"
              aria-labelledby="heading7"
              data-parent="#accordion"
            >
              <div class="card-body">
                Sì, sono validi anche gli acquisti effettuati sui siti
                e-commerce italiani.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading8">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse8"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Cosa posso vincere?
                </button>
              </h5>
            </div>

            <div
              id="collapse8"
              class="collapse"
              aria-labelledby="heading8"
              data-parent="#accordion"
            >
              <div class="card-body">
                Ogni giorno in palio <b>1 montalatte Smeg</b> e ad estrazione
                finale <b>1 kit dolce risveglio Smeg</b> composto da tostapane +
                bollitore + macchina da caffè espresso. La stessa persona non
                può vincere più di un premio a vincita immediata e più di un
                premio ad estrazione.
                <b>Se sarai fortunato potrai vincerli entrambi!</b>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading9">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse9"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Se vinco il premio immediato cosa devo fare?
                </button>
              </h5>
            </div>

            <div
              id="collapse9"
              class="collapse"
              aria-labelledby="heading9"
              data-parent="#accordion"
            >
              <div class="card-body">
                Se vinci il montalatte Smeg devi inviare l’originale del
                documento d’acquisto parlante, riportante i prodotti in
                promozioni acquistati, unitamente ai tuoi dati, indirizzo e alla
                fotocopia di un documento d’identità, tramite Raccomandata entro
                7 giorni dalla vincita (farà fede la data del timbro postale) a:
                <b>Concorso “Glade 2021"</b> c/o Proxima S.p.A. - Via Malavolti,
                59/63 - 41122 Modena (MO). Ti consigliamo di fotocopiare la
                documentazione inviata e di conservarne copia. Saranno prese in
                considerazione tutte le raccomandate pervenute entro il 29 marzo
                2021.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading10">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse10"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Se vinco un premio posso scegliere il colore?
                </button>
              </h5>
            </div>
            <div
              id="collapse10"
              class="collapse"
              aria-labelledby="heading10"
              data-parent="#accordion"
            >
              <div class="card-body">
                Certo! Quando ti registri al concorso puoi indicare di quale
                colore vuoi ricevere il premio in caso di vincita. Puoi
                scegliere, attraverso un menù a tendina, fra i colori: rosso,
                bianco e rosa.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading11">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse11"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  In caso di esito non vincente cosa devo fare?
                </button>
              </h5>
            </div>
            <div
              id="collapse11"
              class="collapse"
              aria-labelledby="heading11"
              data-parent="#accordion"
            >
              <div class="card-body">
                Anche in caso di esito non vincente devi conservare il documento
                d’acquisto parlante. Conservalo almeno fino al 15/10/2021. Ti
                verrà richiesto nel caso di vincita ad estrazione finale.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="heading12">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse12"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Hai bisogno di ulteriori informazioni?
                </button>
              </h5>
            </div>
            <div
              id="collapse12"
              class="collapse"
              aria-labelledby="heading12"
              data-parent="#accordion"
            >
              <div class="card-body">
                Scarica il
                <a target="_blank" href="regolamento.pdf"
                  >regolamento completo</a
                >
                oppure scrivi a
                <a href="mailto:supporto@concorsofaifiorirelatuacasaconglade.it"
                  >supporto@concorsofaifiorirelatuacasaconglade.it</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

 <style lang="css" scoped>
	/* FAQ */
	.card {
		position: relative !important;
		display: -ms-flexbox;
		display: flex !important;
		-ms-flex-direction: column !important;
		flex-direction: column !important;
		min-width: 0 !important;
		word-wrap: break-word !important;
		background-color: #fff !important;
		background-clip: border-box !important;
		border: 1px solid rgba(0, 0, 0, 0.125) !important;
		border-radius: 0.25rem !important;
	}
	#accordion .btn {
		text-transform: inherit;
		color: inherit;
		padding: 0 !important;
		white-space: inherit;
		text-align: left;
		font-size: 1rem !important;
		line-height: 1.3rem;
		width: 100% !important;
	}

	#accordion .card {
		margin-bottom: 1rem;
	}
	.btn:focus {
		box-shadow: none !important;
	}
	.card-header {
		background-color: #fff;
		border-bottom: none;
	}

	.card-body {
		padding: 0 1.25rem 1.25rem;
	}

	.addthis_inline_share_toolbox {
		display: inline-block;
	}

	.insta-download {
		display: inline-block;
		vertical-align: top;
		margin-left: -1px;
		transition: all 0.2s ease-in-out;
	}

	.insta-download:hover {
		transform: translateY(-4px);
	}
</style>
<script>
	import { mapGetters, mapState } from 'vuex';
	import { USER_REQUEST } from 'actions/user';
	import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion';

	export default {
		name: 'faq',
		components: {
			BadgerAccordion,
			BadgerAccordionItem,
		},
		data() {
			return {
				loadingState: '',
				userToken: '',
				concorso: '1',
				pdvBuy: [
					['CISALFA SPORT SPA', 'Cisalfa'],
					['MAISONS DU MONDE ITALIE SPA', 'Maison du Monde'],
					['PAM PANORAMA SPA', 'PAM'],
					['PROFUMERIE DOUGLAS SPA', 'Douglas'],
					['MCS SRL', 'Aldo Shoes'],
					["E' QUI SPA", "E' qui"],
					['THUN SPA', 'Thun'],
					['CENTRI DI BELLEZZA YVES ROCHER ITALIA Y.R.A.M. SRL', 'Yves Rocher'],
					['PRIMADONNA SPA', 'Primadonna'],
					['COMPAR SPA', 'AW Lab'],
					['MCS SRL', 'Napapijri'],
					['H&M HENNES & MAURITZ SRL', 'H&M'],
					['BONNIE SRL', 'Tezenis'],
					['LEONARDO SRL', 'Amore Store'],
					['ZARA ITALIA SRL', 'ZARA'],
					['HANGOVER GROUP SRL', 'Zuiki'],
					['TIGER ITALY 2 SRL', 'Flying Tiger'],
					['PAGANINI ROMA SRL', 'Nuvolari'],
					['NUMBER 1 SRL', 'I Am'],
					['MAYORAL ITALIA SRL', 'Mayoral'],
					['KASANOVA SPA', 'Kasanova'],
					['DP 50 SRL', 'Dental Pro'],
					["101 CAFFE' SRL", '101 Caffè'],
					['GOLD ART STUDIO SRL', 'Gold Art'],
					['SHEKEL SRL', 'Rafi Ruben'],
					['C4 SRL', 'Re Sole'],
					['LOGOS SRL', 'Lama Optical'],
					['COMPANY SRL', 'Sandro Ferrone'],
					['STROILI ORO SPA', 'Stroili Oro'],
					['S. & G. TRADE SPA', 'Skechers'],
					['S. & G. TRADE SPA', 'Adidas'],
					['DAZA SRL', 'Imperial'],
					['AT RETAIL SRL', 'Intimissimi Uomo'],
					['MARI’S 2001 SRL', 'Tiberland'],
					['MARI’S 2001 SRL', 'Wycon'],
					['MARI’S 2001 SRL', 'Tommy/Calvin Klein'],
					['CAMAIEU ITALIA SRL', 'Camaieu'],
					['D.I.P. SPA DIFFUSIONE ITALIANA PREZIOSI', 'Blue Spirit'],
					['SALLY J SRL', 'Calzedonia'],
					['GRANDVISIONITALY SRL UNIPERSONALE', 'Grand Vision'],
					['SIX16TEEN GROUP SRL', 'To Lu'],
					['BERTON LINE SRL', 'Talco'],
					['GRUPPO SASSON SRL', 'Omai'],
					['NAU SPA', 'Nau!'],
					['GRACAFFE’ 2019 SRL', 'CHIOSCO Vergnano'],
					['B PLAN COLORS SRL', 'CHIOSCO Benetton'],
					['A & CD FUTURE COMMUNICATION SRL', 'CHIOSCO WIND-TRE'],
					['NESPRESSO ITALIANA SPA', 'CHIOSCO NESPRESSO'],
					['KAOS CAMPANIA SRL', 'Don Peppe'],
					['ROADHOUSE GRILL ROMA SRL', 'Roadhouse'],
					['GRUPPO NEGOZI SRL', 'La Piadineria'],
					['ROADHOUSE SPA', 'Calavera'],
					['RETAIL SHOP SRL', 'Caporiccio'],
					['DG GROUP SRL', 'Castellese'],
					['PALOMAR SRL', 'Scarpamondo'],
					['MEDIAMARKET SPA', 'MediaWorld'],
					['DENIM FACTORY SRL', 'Live 978'],
					['GRAN FEMME SRL', 'Tagliati per il successo'],
					['GALILEO SPA', 'Satur Passione Casa'],
					['BERSHKA ITALIA SRL', 'Bershka'],
					['PULL&BEAR ITALIA SRL', 'Pull & Bear'],
					['SORBINO RETAIL SPA', 'Sorbino'],
					['STRADIVARIUS ITALIA SRL', 'Stradivarius'],
					['BESTSELLER STORES ITALY SPA', 'Jack & Jones'],
					['PARFUMANIA SRL', 'Estasi Profumerie'],
					['PAGANINI ROMA SRL', 'Project'],
					['4G RETAIL SRL A SOCIO UNICO', 'TIM'],
					['GRABISTROT 2019 SRL', 'Mondo Arancina '],
					['BURGER KING RESTAURANTS ITALIA SRL', 'Burger King'],
					['FOLLYE SRL', 'Marlù'],
					['LIDDO SAMANTA', 'Bottega Verde'],
					['A & CD FUTURE COMMUNICATION SRL', 'Wind Tre'],
					['GIOIELLI DI VALENZA SPA', 'Gioielli di Valenza'],
					['ANDER SRL', 'DVerso'],
					['IMAP EXPORT SPA', 'Original Marines'],
					['VIRTUAL DREAM SRL', 'Dixie'],
					['GUESS ITALIA SRL', 'Guess'],
					['RINAH SPA', 'Dan John'],
					['PRIMITIVE SRL', 'Brend Atelier'],
					['CIDIVERTE SPA', 'Gamelife'],
					['TAILOR MAN SRL', 'Enrico Coveri'],
					['TEDDY SPA', 'Rinascimento'],
					['Q. HELENA SHOES SRL', 'Queen Helena'],
					['GRACAFFE’ 2019 SRL', 'Caffè Vergnano'],
					['MINI PIZZA GASPERINA SRL', 'MINIPIZZA 22CM'],
					['DAN EUROPE SRL', 'Monsanto'],
					['CONBIPEL SPA', 'Conbipel uomo'],
					['SI-COMERCE SRL', 'CHIOSCO Equivalenza '],
					['VACANT', 'CHIOSCO (non commercializzato) '],
					[
						'MISTER GAMES SNC DI CEROCCHI FABIANO E CIUCCOLI ALESSANDRO',
						'CHIOSCO MR GAMES ',
					],
					['ANTARTICA SRL', 'I Baccanali'],
					['UNDIQUE NAPOLI SRL', 'CHIOSCO CAPATOAST'],
					['VODAFONE GESTIONI SPA', 'CHIOSCO VODAFONE'],
					[
						'A & CD FUTURE COMMUNICATION SRL CON UNICO SOCIO',
						'CHIOSCO WIND TRE ',
					],
				],
				pdvOff: [
					['CISALFA SPORT SPA', 'Cisalfa'],
					['PROFUMERIE DOUGLAS SPA', 'Douglas'],
					['MCS SRL', 'Aldo Shoes'],
					["E' QUI SPA", "E' qui"],
					['THUN SPA', 'Thun'],
					['CENTRI DI BELLEZZA YVES ROCHER ITALIA Y.R.A.M. SRL', 'Yves Rocher'],
					['PRIMADONNA SPA', 'Primadonna'],
					['COMPAR SPA', 'AW Lab'],
					['MCS SRL', 'Napapijri'],
					['H&M HENNES & MAURITZ SRL', 'H&M'],
					['BONNIE SRL', 'Tezenis'],
					['LEONARDO SRL', 'Amore Store'],
					['ZARA ITALIA SRL', 'ZARA'],
					['HANGOVER GROUP SRL', 'Zuiki'],
					['TIGER ITALY 2 SRL', 'Flying Tiger'],
					['MAYORAL ITALIA SRL', 'Mayoral'],
					['KASANOVA SPA', 'Kasanova'],
					["101 CAFFE' SRL", '101 Caffè'],
					['GOLD ART STUDIO SRL', 'Gold Art'],
					['C4 SRL', 'Re Sole'],
					['S. & G. TRADE SPA', 'Skechers'],
					['S. & G. TRADE SPA', 'Adidas'],
					['DAZA SRL', 'Imperial'],
					['MARI’S 2001 SRL', 'Tiberland'],
					['MARI’S 2001 SRL', 'Wycon'],
					['MARI’S 2001 SRL', 'Tommy/Calvin Klein'],
					['CAMAIEU ITALIA SRL', 'Camaieu'],
					['D.I.P. SPA DIFFUSIONE ITALIANA PREZIOSI', 'Blue Spirit'],
					['SALLY J SRL', 'Calzedonia'],
					['GRANDVISIONITALY SRL UNIPERSONALE', 'Grand Vision'],
					['SIX16TEEN GROUP SRL', 'To Lu'],
					['BERTON LINE SRL', 'Talco'],
					['GRUPPO SASSON SRL', 'Omai'],
					['NAU SPA', 'Nau!'],
					['GRACAFFE’ 2019 SRL', 'CHIOSCO Vergnano'],
					['B PLAN COLORS SRL', 'CHIOSCO Benetton'],
					['ROADHOUSE GRILL ROMA SRL', 'Roadhouse'],
					['GRUPPO NEGOZI SRL', 'La Piadineria'],
					['ROADHOUSE SPA', 'Calavera'],
					['RETAIL SHOP SRL', 'Caporiccio'],
					['DG GROUP SRL', 'Castellese'],
					['PALOMAR SRL', 'Scarpamondo'],
					['MEDIAMARKET SPA', 'MediaWorld'],
					['DENIM FACTORY SRL', 'Live 978'],
					['GRAN FEMME SRL', 'Tagliati per il successo'],
					['BERSHKA ITALIA SRL', 'Bershka'],
					['PULL&BEAR ITALIA SRL', 'Pull & Bear'],
					['SORBINO RETAIL SPA', 'Sorbino'],
					['STRADIVARIUS ITALIA SRL', 'Stradivarius'],
					['BESTSELLER STORES ITALY SPA', 'Jack & Jones'],
					['PARFUMANIA SRL', 'Estasi Profumerie'],
					['4G RETAIL SRL A SOCIO UNICO', 'TIM'],
					['GRABISTROT 2019 SRL', 'Mondo Arancina '],
					['BURGER KING RESTAURANTS ITALIA SRL', 'Burger King'],
					['FOLLYE SRL', 'Marlù'],
					['LIDDO SAMANTA', 'Bottega Verde'],
					['A & CD FUTURE COMMUNICATION SRL', 'Wind Tre'],
					['GIOIELLI DI VALENZA SPA', 'Gioielli di Valenza'],
					['ANDER SRL', 'DVerso'],
					['IMAP EXPORT SPA', 'Original Marines'],
					['VIRTUAL DREAM SRL', 'Dixie'],
					['GUESS ITALIA SRL', 'Guess'],
					['PRIMITIVE SRL', 'Brend Atelier'],
					['CIDIVERTE SPA', 'Gamelife'],
					['TAILOR MAN SRL', 'Enrico Coveri'],
					['TEDDY SPA', 'Rinascimento'],
					['Q. HELENA SHOES SRL', 'Queen Helena'],
					['GRACAFFE’ 2019 SRL', 'Caffè Vergnano'],
					['MINI PIZZA GASPERINA SRL', 'MINIPIZZA 22CM'],
					['DAN EUROPE SRL', 'Monsanto'],
					['CONBIPEL SPA', 'Conbipel uomo'],
					['SI-COMERCE SRL', 'CHIOSCO Equivalenza '],
					['ANTARTICA SRL', 'I Baccanali'],
					['UNDIQUE NAPOLI SRL', 'CHIOSCO CAPATOAST'],
				],
			};
		},
		methods: {},
		watch: {},
		mounted: function () {
			var pdvBuy = this.pdvBuy;
			pdvBuy.sort((a, b) => a[1].localeCompare(b[1]));
			this.pdvBuy = pdvBuy;

			var pdvOff = this.pdvBuy;
			pdvOff.sort((a, b) => a[1].localeCompare(b[1]));
			this.pdvOff = pdvOff;
			if (this.$route.query) {
				if (this.$route.query.concorso) {
					this.concorso = this.$route.query.concorso;
				}
			}
		},
		computed: {
			...mapGetters([
				'getProfile',
				'isAuthenticated',
				'isProfileLoaded',
				'acceptCookies',
				'promoOpen',
				'getPromotions',
			]),
			...mapState({
				authLoading: (state) => state.auth.status === 'loading',
				nome: (state) => `${state.user.profile.nome}`,
			}),
		},
	};
</script>


